export default {"src":"/hedera/_next/static/media/support_dark.b992f872.svg","height":24,"width":24};